import React from 'react';

import classNames from 'classnames';
import { useSortable } from '@dnd-kit/sortable';

import { RiDraggable } from 'react-icons/ri';
import { MdExpandLess } from 'react-icons/md';
import { FiMoreVertical } from 'react-icons/fi';

import PopOver from 'components/common/popover';

import { TYPE_ATTRIBUTES } from 'constants/linkLibrary';

import type { LinkLibraryTreeNode } from 'interface/linkLibraryTree';

type SortableAttributes = ReturnType<typeof useSortable>['attributes'];
type SortableListeners = ReturnType<typeof useSortable>['listeners'];

interface PopperData {
  styles: Record<string, string | number>;
}

interface Props {
  listData: LinkLibraryTreeNode;
  setListData: React.Dispatch<React.SetStateAction<LinkLibraryTreeNode>>;
  attributes: SortableAttributes;
  listeners: SortableListeners;
  setActivatorNodeRef: (element: HTMLElement | null) => void;
  nodeLevel: number;
  activePopoverId: string | null;
  setActivePopoverId: React.Dispatch<React.SetStateAction<string | null>>;
}

const SortableHeaderRow: React.FC<Props> = ({
  listData,
  setListData,
  attributes,
  listeners,
  setActivatorNodeRef,
  nodeLevel,
  activePopoverId,
  setActivePopoverId,
}) => {
  const handleRowClick = () => {
    setListData((prev) => {
      return {
        ...prev,
        isExpanded: !prev.isExpanded,
      };
    });
  };

  const typeAttributes = TYPE_ATTRIBUTES[listData.type as keyof typeof TYPE_ATTRIBUTES];
  const popoverId = `${listData.type}-${listData.id}`;

  return (
    <div className="rst__row" onClick={handleRowClick}>
      <div className="rst__row-wrapper">
        <div className={typeAttributes.headerClass(nodeLevel)}>
          <div ref={setActivatorNodeRef} {...attributes} {...listeners} className="rst__row-draggableIcon">
            <RiDraggable />
          </div>
          <span className={typeAttributes.titleClass}>{listData.name}</span>
          <div
            className={classNames('rst__dropIcon', {
              'rst__dropIcon--active': !listData.isExpanded,
            })}
          >
            <MdExpandLess />
          </div>
        </div>
        <span
          className="vertical-ellipsis"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
        >
          <PopOver
            interactive
            theme="light"
            open={activePopoverId === popoverId}
            onRequestClose={() => setActivePopoverId(null)}
            size="small"
            position="left-start"
            distance={5}
            disableOnScroll={true}
            popperOptions={{
              modifiers: {
                addZIndex: {
                  enabled: true,
                  order: 810,
                  fn: (data: PopperData) => ({
                    ...data,
                    styles: {
                      ...data.styles,
                      zIndex: 10,
                    },
                  }),
                },
              },
            }}
            html={typeAttributes.html(listData, handleRowClick, popoverId, setActivePopoverId)}
            className="vertical-ellipsis__menu dots-menu"
          >
            <FiMoreVertical
              className="grey--text"
              size={24}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setActivePopoverId(activePopoverId === popoverId ? null : popoverId);
              }}
            />
          </PopOver>
        </span>
      </div>
    </div>
  );
};

export default SortableHeaderRow;
